/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at Fri Apr 14 2023
 **/

import { useEffect } from "react";
import { fromEvent, timer, Subscription } from "rxjs";
import useAutoEvent from "./useAutoEvent";

let timerId: Subscription | null = null;
type KeyPressCallback = (e: any, isLongPress: boolean, isKeyup: boolean) => void;
export default function useKeyPress(callback: KeyPressCallback) {
	let isPressed = false;

	useAutoEvent([
		{
			event: fromEvent(window, "keydown"),
			handler(e: any) {
				if (e.repeat === false) {
					isPressed = false;
				} else {
					if (isPressed === false) {
						timerId = timer(300).subscribe(() => {
							if (isPressed) {
								e.stopImmediatePropagation();
								e.preventDefault();
								callback(e, true, false);
							}
							timerId = null;
						});
					}
					isPressed = true;
				}
			}
		},
		{
			event: fromEvent(window, "keyup"),
			handler(e: any) {
				e.stopImmediatePropagation();
				e.preventDefault();
				callback(e, isPressed, true);
				isPressed = false;
				timerId?.unsubscribe();
				timerId = null;
			}
		}
	]);

	useEffect(() => {
		return () => {
			timerId?.unsubscribe();
			timerId = null;
		};
	}, []);
}
